import script from "./TabSwitchPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TabSwitchPanel.vue?vue&type=script&setup=true&lang=js"

import "./TabSwitchPanel.vue?vue&type=style&index=0&id=85e47c22&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85e47c22"]])

export default __exports__